import { CAP } from "../data/mockData";
import { resolveImage } from "../data/assetMap";

// Builds the BottomSheet's item list for whichever tagging flow is open:
// picking a document requirement, a government ID type, or a bank name.
export function buildSheetItems({ sheet, docs, docsFor, capFor, reqLabel, selectedBanks, tagTo, tagGov, tagBank, attach, pending, govIdTypeLabels, setSheet, categories, bankReqId, govReqId, flash }) {
  if (!sheet) return [];

  if (sheet.kind === "req") {
    const items = [];
    categories.forEach((c) =>
      c.reqs.forEach((label, i) => {
        const reqId = c.key + "-" + i;
        const n = docsFor(reqId).length;
        const cap = capFor ? capFor(reqId) : CAP;
        const full = n >= cap;
        items.push({
          key: reqId,
          label,
          meta: c.name + (n ? " · " + n + "/" + cap : ""),
          full,
          tag: full ? "Full" : "",
          tagStyle: { color: "var(--ink-500)", background: "var(--ink-050)" },
          onClick: () => {
            if (!full) tagTo(sheet.docId, reqId);
          },
        });
      })
    );
    return items;
  }

  if (sheet.kind === "gov") {
    const govDocs = docs.filter((d) => d.req === govReqId && d.govType);
    const govUsed = [];
    govDocs.forEach((d) => {
      if (!govUsed.includes(d.govType)) govUsed.push(d.govType);
    });
    return (govIdTypeLabels || []).map((label) => ({
      key: label,
      label,
      meta: govUsed[0] === label ? "Already used as the primary ID" : govUsed[1] === label ? "Already used as the secondary ID" : "",
      tag: govUsed[0] === label ? "Primary" : govUsed[1] === label ? "Secondary" : "",
      tagStyle: govUsed[0] === label ? { color: "#2F6BC4", background: "#E3F0FF" } : { color: "#7B47C9", background: "#F0E5FF" },
      onClick: () => {
        if (sheet.docId) {
          tagGov(sheet.docId, label);
          return;
        }
        const items = (pending || []).map((it) => ({ ...it, govType: label }));
        setSheet(null);
        attach(govReqId, items.length ? items : [{ name: "Gov_ID_" + label.replace(/[^a-z0-9]+/gi, "_") + ".pdf", govType: label, prev: "placeholder-id-card.png" }]);
      },
    }));
  }

  if (sheet.kind === "bank") {
    // One HL application form per financier — a bank that already has one
    // (other than the doc being re-tagged) can't take another.
    const bankTagged = docs.filter((d) => d.req === bankReqId && d.bankName && d.id !== sheet.docId).map((d) => d.bankName);
    return selectedBanks().map((b) => ({
      key: b.key,
      label: b.name,
      logoUrl: resolveImage(b.logo),
      meta: bankTagged.includes(b.name) ? "A form is already attached for this bank" : "No form attached yet",
      full: bankTagged.includes(b.name),
      tag: bankTagged.includes(b.name) ? "Attached" : "",
      tagStyle: { color: "#2E7D32", background: "#E8F5E9" },
      onClick: () => {
        if (bankTagged.includes(b.name)) {
          if (flash) flash("A form is already attached for " + b.name);
          return;
        }
        if (sheet.docId) {
          tagBank(sheet.docId, b.name);
          return;
        }
        const items = (pending || []).slice(0, 1).map((it) => ({ ...it, bankName: b.name, financierId: b.key }));
        if ((pending || []).length > 1 && flash) flash("Only one form per financier — attached the first file");
        setSheet(null);
        attach(
          bankReqId,
          items.length ? items : [{ name: "HL_Application_" + b.name.replace(/[^a-z0-9]+/gi, "_") + ".pdf", bankName: b.name, financierId: b.key, prev: "placeholder-document-doc.png" }]
        );
      },
    }));
  }

  return [];
}
